export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2021.eec40cdb.pdf";